import type { PropsWithChildren } from 'react'
import { Image } from '../Image/Image';

type RecipientCountryProps = PropsWithChildren & {
  isoCode: string;
};

export const RecipientCountry = ( { children, isoCode }: RecipientCountryProps ) => {

  return (
    <p className={ 'text-xs flex flex-row gap-1.5' }>
      <Image
        src={ `https://images.rewarble.com/flags/${ isoCode.toUpperCase() }.svg` }
        config={ 'format-webp format-png w-[20px] fit-contain' }
        className={ 'w-[20px] h-auto rounded-sm border border-[#FFFFFF80]' }
        width={ 20 }
        height={ 20 }
      />
      {children}
    </p>
  )
}
RecipientCountry.displayName = 'RecipientCountry';
